import { render, staticRenderFns } from "./PostInterestedScl.vue?vue&type=template&id=6b48887b&"
import script from "./PostInterestedScl.vue?vue&type=script&lang=js&"
export * from "./PostInterestedScl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports